
import HearingTestButton from "../hearingTestButton/hearingTestButton";
import FormActionButton from "../formActionButton/formActionButton";
import PillTitle from "../pillTitle/pillTitle";
import { useI18n } from "../../utils/translate/i18n/useI18n";
import type { Ear } from "../../type/tonalTest";

export default function EarSelection({
  onSelect,
  onNewTest,
}: {
  onSelect: (ear: Ear) => void;
  onNewTest: () => void;
}) {
  const { t } = useI18n();

  return (
    <div className="panel panel--runtest card border-0">
      <div className="card-body">
        <div className="d-flex justify-content-between align-items-center mb-3">
          <PillTitle as="div" variant="blue-darkner" iconClassName="bi bi-ear" text={t("Wybór ucha")} className="mb-0" />
          <FormActionButton
            type="button"
            variant="outline-white"
            size="xs"
            iconClassName="bi bi-arrow-repeat"
            onClick={onNewTest}
            title={t("Nowy test")}
          >
            {t("Nowy test")}
          </FormActionButton>
        </div>

        <h2 className="mb-3">{t("Które ucho chcesz zbadać teraz?")}</h2>

        <div className="panel--runtest__notice_area">
          <p className="mb-3 panel--runtest__notice_text">
            {t("Po wybraniu ucha rozpocznie się test. Po zakończeniu badania wybranego ucha automatycznie rozpocznie się badanie drugiego ucha.")}
          </p>

        <div className="row g-3 justify-content-center mt-1">
          <div className="col-12 col-md-6">
            <HearingTestButton type="button" className="btn btn-outline-light btn-lg px-4 w-100" iconClassName="bi bi-ear" onClick={() => onSelect("left")}>
              {t("Lewe ucho")}
            </HearingTestButton>
          </div>
          <div className="col-12 col-md-6">
            <HearingTestButton type="button" className="btn btn-outline-light btn-lg px-4 w-100" iconClassName="bi bi-ear" onClick={() => onSelect("right")}>
              {t("Prawe ucho")}
            </HearingTestButton>
          </div>
        </div>
        </div>
      </div>
    </div>
  );
}